<template>
  <div class="mb-2">
    <label
        for="pos-print"
        class="form-label"
    >
      Pos Print Size(MM)
    </label>
    <input
        type="number"
        class="form-control width-20-per"
        id="pos-print"
        v-model="posPrintSize"
        @change="handlePosPrintSizeChange"
    >
  </div>

  <div class="form-check form-switch d-flex align-items-center gap-2 ps-0 mb-2">
    <label
        class="form-check-label"
        for="is-voucher-approval-enabled"
    >
      Pos Bill Marketing Direct Incentive Allow
    </label>
    <input
        v-model="isPosBillMarketingIncentiveAllow"
        class="form-check-input m-0"
        type="checkbox"
        role="switch"
        id="is-voucher-approval-enabled"
        @click="handlePosBillMarketingIncentiveAllow"
    />
  </div>

    <GlobalLoader />
</template>

<script setup>
import {inject, onMounted, ref} from "vue";
    import handleCompany from "@/services/modules/company";
    import GlobalLoader from "@/components/atom/GlobalLoader.vue";
    import {useStore} from "vuex";
    import {useRoute} from "vue-router";

    const posPrintSize = ref(null)
    const isPosBillMarketingIncentiveAllow = ref(false)
    const { getCompanyPreferences, modifyCompanyPreference } = handleCompany();
    const $store = useStore();
    const $route = useRoute();
    const showSuccess =  inject('showSuccess');
    const companyId = $route.params.companyId;

    const handlePosPrintSizeChange = (e) => {
        const nextValue = e.target.value;

        const data = {
            company_id: companyId,
            field: "pos_print_size",
            value: nextValue,
        };

        handleUpdate(data);
    }

    const handlePosBillMarketingIncentiveAllow = (e) => {
      const nextValue = e.target.checked;

      const data = {
        company_id: companyId,
        field: "pos_bill_marketing_incentive_allow",
        value: nextValue,
      };

      handleUpdate(data);
    }

    const handleUpdate = (data) => {
        $store.state.loading = true;

        modifyCompanyPreference(data)
            .then((res) => {
                showSuccess(res.message);
            })
            .finally(() => ($store.state.loading = false));
    }

    const getInitialValue = (data, field) => {
        const item = data.find((item => item.field === field))

        return item ? item.value : null;
    }

    const parseBoolean = (v) => {
      if (typeof v === "boolean") return v;
      if (typeof v === "number") return v === 1;
      if (typeof v === "string") return v.trim() === "1";
      return false;
    }

    onMounted(() => {
        $store.state.loading = true

        const queryObject = {
            company_id: companyId,
            fields: 'pos_print_size,pos_bill_marketing_incentive_allow'
        }
        const query = '?' + new URLSearchParams(queryObject).toString();

        getCompanyPreferences(query)
            .then(res => {
              if (res.data){
                const data = res.data;
                posPrintSize.value = getInitialValue(data, 'pos_print_size')
                isPosBillMarketingIncentiveAllow.value = parseBoolean(getInitialValue(data, 'pos_bill_marketing_incentive_allow'))
              }
            })
            .finally(() => $store.state.loading = false);
    });
</script>